import { render, staticRenderFns } from "./shop-delete-modal.vue?vue&type=template&id=1f880028&scoped=true&"
import script from "./shop-delete-modal.vue?vue&type=script&lang=js&"
export * from "./shop-delete-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f880028",
  null
  
)

export default component.exports